export enum CronSelections {
	Every = 'Every',
	At = 'At',
}

export enum DaysBySelections {
	Week = 'Week',
	Month = 'Month',
}
